import React from 'react';
import { CnResult } from "@alife/cn-ui";
import './index.scss';
export default (props) => {
    return React.createElement(CnResult, { ...props, className: "cn-intelli-assistant-result" });
};
